import React from "react";
import { FormHelperText, FormControl } from "@material-ui/core"
import _ from 'lodash';

import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

import { useField } from "react-final-form-hooks";

export default function ({ form, name, label, icon, type, children, hint, options, hidden, onChange,  ...props }) {
    const field = useField(name, form);
    let selectItems = (options || []).map((_option) => {
        const selected = _option.value === field.input.value;
        return (
          <ToggleButton
            value={_option.value}
            key={_option.value}
            style={{
                flex: 1,
                marginTop: "1px",
                backgroundColor: selected ? "#ffd900" : "transparent",
                color: selected ? "#756500" : "#bbb",
                borderColor: "#ddd"
            }}
          >
            <div className="px-2 nowrap">{_option.label}</div>
          </ToggleButton>
        );
    })
    const _onChange = (event, val) => {
      if(_.isFunction(onChange)) onChange(event, val);
      if (val === null) return;
      field.input.onChange(val);
    }

    if(hidden){
        return null;
    }

    return (
        <FormControl margin="normal" fullWidth>
          <ToggleButtonGroup
            size="small"
            className="fullwidth flex-row"
            {...field.input}
            value={field.input.value}
            onChange={_onChange}
            exclusive
          >
            {selectItems}
          </ToggleButtonGroup>
          {(field.meta.touched && field.meta.error) ? <FormHelperText>{field.meta.error}</FormHelperText> : null}
        </FormControl>
    );
}
